export default "__VITE_ASSET__ypeiVxxh__"